var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"core-infinite-scroll-item"},[_vm._t("default",null,{"item":_vm.source,"index":_vm.index})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }